import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.TAG_LIST_CLEAR_STORE){

        let oldTagList = undefined;
        if(!!state){
            oldTagList = state.tagList;
        }

        state = {
            name: "Тест",

            tagListSummury: [],
            tagList: oldTagList || [],
            userList: [],
            isLoading: false,
            isSave: false,
            isLoaded: false
        };

    }

    switch(action.type){
        case constants.TAG_LIST_SUMMURY_LOAD_START:
            return {...state, ...{tagListSummury: [], isLoading: true, error: undefined}};
        case constants.TAG_LIST_SUMMURY_LOAD_SUCCESS:
            return { ...state, ...{tagListSummury: action.data, isLoading: false}};
        case constants.TAG_LIST_SUMMURY_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.TAG_LIST_LOAD_START:
            return {...state, ...{tagList: [], isLoading: true, error: undefined}};
        case constants.TAG_LIST_LOAD_SUCCESS:
            return { ...state, ...{tagList: action.data, isLoading: false}};
        case constants.TAG_LIST_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.TAG_LIST_REMOVE_START:
            return {...state, ...{isLoading: true}};
        case constants.TAG_LIST_REMOVE_SUCCESS:
            return { ...state, ...{isLoading: false, isShouldReload: true}};
        case constants.TAG_LIST_REMOVE_FAIL:
            return {...state, ...{isLoading: true, error: action.error}};

        default:
            return state;
    }
}
